import useMotionPreference from "@/hooks/useMotionPreference";
import { useEffect } from "react";
import Lenis from "lenis";

const absoluteTop = element => element.getBoundingClientRect().top + window.scrollY;

function anchorDestination(id, element) {
  const scene = element.matches("[data-scene-count]") ? element : element.querySelector("[data-scene-count]");
  if (scene) {
    const count = Number(scene.dataset.sceneCount);
    const travel = Math.max(0, scene.offsetHeight - window.innerHeight);
    if (count > 1) return absoluteTop(scene) + travel * (1.2 / (count + 1));
  }

  if (id === "github") {
    const profile = element.querySelector("[data-github-profile]");
    if (profile) return absoluteTop(profile) - Math.max(112, Math.min(180, window.innerHeight * 0.16));
  }

  return absoluteTop(element) - 80;
}

export default function SmoothScroll({ children }) {
  const reduceMotion = useMotionPreference();
  useEffect(() => {
    const lenis = reduceMotion ? null : new Lenis({
      duration: 1.1,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    if (lenis) raf = requestAnimationFrame(loop);

    const handler = (e) => {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      const a = e.target.closest?.('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.getElementById(id.slice(1));
        if (el) {
          e.preventDefault();
          window.dispatchEvent(new CustomEvent("portfolio:navigate", { detail: { id: id.slice(1) } }));
          window.history.replaceState(window.history.state, "", id);
          const top = Math.max(0, anchorDestination(id.slice(1), el));
          if (lenis) lenis.scrollTo(top);
          else window.scrollTo({ top, behavior: "instant" });
        }
      }
    };
    document.addEventListener("click", handler);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", handler);
      lenis?.destroy();
    };
  }, [reduceMotion]);
  return children;
}
